import * as validate from 'validate.js';
export const comprobarDatos = (datos, reglas, alias = {}) => {
    return new Promise((resolve, reject) => {
        validate.async(datos, reglas, {
            prettify: function prettify(string) {
                return alias[string] || validate.prettify(string);
            }
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
}